/**
 * Timeline component
 */
(function () {
  // Wait for DOM to be ready
  function onDOMReady(callback) {
    if (document.readyState !== 'loading') {
      callback();
    } else {
      document.addEventListener('DOMContentLoaded', callback);
    }
  }

  // Main initialization
  onDOMReady(function () {
    console.log('Timeline component initializing');

    // Get all timelines on the page
    const timelines = document.querySelectorAll('.timeline');
    console.log('Timelines found:', timelines.length);

    if (timelines.length === 0) {
      console.error('No timelines found with selector .timeline');
      return;
    }

    // Initialize all timelines
    let currentWindowHeight = window.innerHeight;

    // Flag to disable auto-updating during manual clicks
    let disableAutoUpdate = false;

    // Initialize each timeline
    timelines.forEach(function (timeline) {
      console.log('Initializing timeline');
      initializeTimeline(timeline);
    });

    // Setup global listeners
    setupResizeListener();
    setupScrollListener();

    // Initialize a single timeline
    function initializeTimeline(timeline) {
      // Find the years container
      const timelineYears = timeline.querySelector('.timeline__years');
      if (!timelineYears) {
        console.error('No .timeline__years found in timeline');
        return;
      }

      // Find skip buttons and add event listeners
      const skipButtons = timeline.querySelectorAll('.skip-to-next');
      skipButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          const paragraph = this.closest('.paragraph');
          if (!paragraph) return;

          const topOffset = paragraph.offsetTop - 100;
          const height = paragraph.offsetHeight;

          window.scrollTo({
            top: topOffset + height,
            behavior: 'smooth'
          });
        });
      });

      // Build article index by finding actual article years
      const articleIndex = buildArticleYearIndex(timeline);
      console.log('Article year index:', articleIndex);

      // Clear existing years container
      timelineYears.innerHTML = '';

      // Build the year navigation
      articleIndex.forEach(function (item, i) {
        // Create the year list item
        const li = document.createElement('li');
        li.className = `timeline-year-item${i === 0 ? ' --active' : ''}${i === 1 ? ' --active-after' : ''}${i === 2 ? ' --active-after-2' : ''}${i === 3 ? ' --active-after-3' : ''}`;

        // Create the year button
        const button = document.createElement('button');
        button.setAttribute('type', 'button');
        button.setAttribute('data-first-article', item.articleID);
        button.setAttribute('data-year', item.year);
        button.className = 'timeline-year';
        button.textContent = item.year;

        // Add the button to the list item
        li.appendChild(button);
        timelineYears.appendChild(li);

        // Add click event to the button
        button.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          const newYear = this.getAttribute('data-year');
          const activeButton = timeline.querySelector('.timeline-year-item.--active > .timeline-year');
          const previousYear = activeButton ? activeButton.getAttribute('data-year') : null;

          if (previousYear !== newYear) {
            // This is a manual year change - disable auto-updating temporarily
            disableAutoUpdate = true;

            setActiveYear(this);
            updateTimelinePosition(this);
            scrollToArticle(this.getAttribute('data-first-article'), timeline);

            // Re-enable auto-updating after scrolling completes
            setTimeout(function () {
              disableAutoUpdate = false;
            }, 1000);
          }
        });

        // Update the select dropdown if it exists
        const yearsSelect = timeline.querySelector('.timeline__years-select');
        if (yearsSelect) {
          const option = document.createElement('option');
          option.setAttribute('data-year', item.year);
          option.value = item.articleID;
          if (i === 0) option.selected = true;
          option.textContent = item.year;
          yearsSelect.appendChild(option);
        }
      });

      // Make all timeline items focusable and set data-year attribute for each
      const timelineItems = timeline.querySelectorAll('.timeline__content > a, .timeline__content a');
      timelineItems.forEach(function (item) {
        item.setAttribute('tabindex', '-1');

        // Get the year information from our articleIndex
        const itemId = item.getAttribute('id') || '';
        const year = item.getAttribute('data-year');

        if (!year) {
          // Find the year for this item by checking its content
          for (let i = 0; i < articleIndex.length; i++) {
            if (articleIndex[i].articles.includes(item)) {
              item.setAttribute('data-year', articleIndex[i].year);
              break;
            }
          }
        }
      });

      // Setup navigation controls
      setupControls(timeline);

      // Initialize the first year
      const firstYearItem = timelineYears.querySelector('.timeline-year-item');
      if (firstYearItem) {
        const firstYearButton = firstYearItem.querySelector('.timeline-year');
        if (firstYearButton) {
          const firstYearHeight = firstYearItem.offsetHeight;
          const firstYearHeightHalf = firstYearHeight / 2;

          // Center the first year
          timelineYears.style.transform = `translate3d(0, -${firstYearHeightHalf}px, 0)`;

          // Set the first year as active
          setActiveYear(firstYearButton);
        }
      }

      // Check initial viewport
      checkTimelineInViewport(timeline);
    }

    // Build article index by finding the actual year for each article
    function buildArticleYearIndex(timeline) {
      const articlesByYear = {};
      const links = timeline.querySelectorAll('.timeline__content > a, .timeline__content a');

      links.forEach(function (link) {
        let year = link.getAttribute('data-year');

        // Extract year from URL or content if `data-year` is missing
        if (!year) {
          const href = link.getAttribute('href') || '';
          const urlYearMatch = href.match(/\/(19|20)\d{2}\/|-(19|20)\d{2}$/);
          if (urlYearMatch) {
            year = urlYearMatch[0].match(/(19|20)\d{2}/)[0];
          }
        }

        // Extract year from nearby date elements
        if (!year) {
          const articleContainer = link.closest('article') || link.closest('.timeline-item');
          if (articleContainer) {
            const dateEl = articleContainer.querySelector('.date, time, .field-date');
            if (dateEl) {
              const dateText = dateEl.textContent || dateEl.getAttribute('datetime') || '';
              const dateMatch = dateText.match(/(19|20)\d{2}/);
              if (dateMatch) {
                year = dateMatch[0];
              }
            }
          }
        }

        // Fallback: Infer year based on position
        if (!year) {
          year = 'Unknown'; // Assign a default value if no year is found
        }

        // Group articles by year
        if (!articlesByYear[year]) {
          articlesByYear[year] = [];
        }
        articlesByYear[year].push(link);

        // Set `data-year` attribute on the link
        link.setAttribute('data-year', year);
      });

      // Convert the map to an array of years
      return Object.keys(articlesByYear).sort().reverse().map(function (year) {
        return {
          year: year,
          articles: articlesByYear[year],
          articleID: `year-${year}`
        };
      });
    }

    // Setup control buttons
    function setupControls(timeline) {
      // Previous year button
      const prevButton = timeline.querySelector('.timeline__control--prev');
      if (prevButton) {
        prevButton.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          const activeItem = timeline.querySelector('.timeline-year-item.--active');
          if (!activeItem) return;

          const prevItem = activeItem.previousElementSibling;
          if (!prevItem) return;

          const prevButton = prevItem.querySelector('.timeline-year');
          if (prevButton) prevButton.click();
        });
      }

      // Previous rewind button (first)
      const prevRwButton = timeline.querySelector('.timeline__control--prev-RW');
      if (prevRwButton) {
        prevRwButton.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          const firstButton = timeline.querySelector('.timeline__years li:first-child .timeline-year');
          if (firstButton) firstButton.click();
        });
      }

      // Next year button
      const nextButton = timeline.querySelector('.timeline__control--next');
      if (nextButton) {
        nextButton.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          const activeItem = timeline.querySelector('.timeline-year-item.--active');
          if (!activeItem) return;

          const nextItem = activeItem.nextElementSibling;
          if (!nextItem) return;

          const nextButton = nextItem.querySelector('.timeline-year');
          if (nextButton) nextButton.click();
        });
      }

      // Next fast forward button (last)
      const nextFfButton = timeline.querySelector('.timeline__control--next-FF');
      if (nextFfButton) {
        nextFfButton.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          const lastButton = timeline.querySelector('.timeline__years li:last-child .timeline-year');
          if (lastButton) lastButton.click();
        });
      }

      // Year selection dropdown
      const yearSelect = timeline.querySelector('.timeline__years-select');
      if (yearSelect) {
        yearSelect.addEventListener('change', function (e) {
          const articleID = this.value;
          const selectedOption = this.options[this.selectedIndex];
          const year = selectedOption.getAttribute('data-year');

          const yearButton = timeline.querySelector(`.timeline-year[data-year="${year}"]`);
          if (yearButton) {
            // Disable auto-updating temporarily
            disableAutoUpdate = true;

            setActiveYear(yearButton);
            scrollToArticle(articleID, timeline);

            // Re-enable auto-updating after scrolling completes
            setTimeout(function () {
              disableAutoUpdate = false;
            }, 1000);
          }
        });
      }
    }

    // Set the active year
    function setActiveYear(yearButton) {
      if (!yearButton) return;

      const timeline = yearButton.closest('.timeline');
      if (!timeline) return;

      const timelineYears = yearButton.closest('.timeline__years');
      if (!timelineYears) return;

      const activeItem = yearButton.parentElement;
      if (!activeItem) return;

      // Get neighboring items
      const prevItem = activeItem.previousElementSibling;
      const nextItem = activeItem.nextElementSibling;
      const prevItem2 = prevItem ? prevItem.previousElementSibling : null;
      const nextItem2 = nextItem ? nextItem.nextElementSibling : null;
      const prevItem3 = prevItem2 ? prevItem2.previousElementSibling : null;
      const nextItem3 = nextItem2 ? nextItem2.nextElementSibling : null;

      // Remove all active classes
      const allItems = timelineYears.querySelectorAll('.timeline-year-item');
      allItems.forEach(function (item) {
        item.classList.remove(
          '--active',
          '--active-after',
          '--active-after-2',
          '--active-after-3',
          '--active-before',
          '--active-before-2',
          '--active-before-3'
        );
      });

      // Add appropriate classes
      activeItem.classList.add('--active');
      if (prevItem) prevItem.classList.add('--active-before');
      if (nextItem) nextItem.classList.add('--active-after');
      if (prevItem2) prevItem2.classList.add('--active-before-2');
      if (nextItem2) nextItem2.classList.add('--active-after-2');
      if (prevItem3) prevItem3.classList.add('--active-before-3');
      if (nextItem3) nextItem3.classList.add('--active-after-3');

      // Update select if it exists
      const yearValue = yearButton.getAttribute('data-year');
      const yearSelect = timeline.querySelector('.timeline__years-select');

      if (yearSelect) {
        for (let i = 0; i < yearSelect.options.length; i++) {
          if (yearSelect.options[i].getAttribute('data-year') === yearValue) {
            yearSelect.selectedIndex = i;
            break;
          }
        }
      }

      // Update control buttons visibility
      updateControlButtons(timeline);
    }

    // Update the timeline vertical position
    function updateTimelinePosition(yearButton) {
      if (!yearButton) return;

      const timelineYears = yearButton.closest('.timeline__years');
      if (!timelineYears) return;

      const yearItem = yearButton.parentElement;
      if (!yearItem) return;

      // Calculate the vertical position
      const itemTop = yearItem.offsetTop;
      const itemHeight = yearItem.offsetHeight;
      const adjustment = itemHeight / 2 + itemTop;

      // Apply the transform
      timelineYears.style.transform = `translate3d(0, -${adjustment}px, 0)`;
    }

    // Scroll to a specific article or link
    function scrollToArticle(articleID, timeline) {
      if (!articleID || !timeline) {
        console.error("Missing articleID or timeline in scrollToArticle");
        return;
      }

      // Use our stored link map
      let target = null;

      // Check if we have a direct reference to this link
      if (timeline._linkMap && timeline._linkMap[articleID]) {
        target = timeline._linkMap[articleID];
      } else {
        console.error(`Target not found for ID: ${articleID}`);
        return;
      }

      // Calculate scroll position
      const rect = target.getBoundingClientRect();
      const scrollTop = window.pageYOffset + rect.top - (currentWindowHeight / 2 - 150);

      // Smooth scroll to target
      window.scrollTo({
        top: scrollTop,
        behavior: 'smooth'
      });

      // Update focus state
      const forwardItems = timeline.querySelectorAll('.timeline__content a.--article-forward');
      forwardItems.forEach(function (item) {
        item.classList.remove('--article-forward');
      });

      target.classList.add('--article-forward');
      target.focus();
    }

    // Update control buttons visibility
    function updateControlButtons(timeline) {
      if (!timeline) return;

      const years = timeline.querySelectorAll('.timeline__years li');
      if (years.length === 0) return;

      const activeYear = timeline.querySelector('.timeline-year-item.--active');
      if (!activeYear) return;

      const activeIndex = Array.from(years).indexOf(activeYear);

      // Update rewind button
      const rwButton = timeline.querySelector('.timeline__control--prev-RW');
      if (rwButton) {
        if (activeIndex > 0) {
          rwButton.classList.add('RW-reveal');
        } else {
          rwButton.classList.remove('RW-reveal');
        }
      }

      // Update fast forward button
      const ffButton = timeline.querySelector('.timeline__control--next-FF');
      if (ffButton) {
        if (activeIndex < years.length - 1) {
          ffButton.classList.add('FF-reveal');
        } else {
          ffButton.classList.remove('FF-reveal');
        }
      }
    }

    // Check if timeline is in viewport and update active year based on visible items
    function checkTimelineInViewport(timeline) {
      // Skip auto-updating if in manual navigation mode
      if (!timeline || !isElementInViewport(timeline) || disableAutoUpdate) return;

      // Check for articles directly
      const timelineArticles = timeline.querySelectorAll('.timeline__content article, .timeline__content .timeline-manual-item');

      if (timelineArticles.length > 0) {
        // Remove the class from all articles first
        timelineArticles.forEach(function (article) {
          article.classList.remove('--article-forward');
        });

        // Check which article is visible and update
        for (let i = 0; i < timelineArticles.length; i++) {
          const article = timelineArticles[i];
          const rect = article.getBoundingClientRect();

          // Adjust the threshold for when an article becomes active
          const thresholdStart = window.innerHeight * 0.1; // 10% from the top of the viewport
          const thresholdEnd = window.innerHeight * 0.75; // 75% from the top of the viewport

          if (rect.top >= thresholdStart && rect.top < thresholdEnd) {
            // Add the class to the article in viewport
            article.classList.add('--article-forward');

            // Remove the class from the previous article slightly later
            if (i > 0) {
              const previousArticle = timelineArticles[i - 1];
              const prevRect = previousArticle.getBoundingClientRect();

              // Ensure the previous article is fully out of the threshold range
              if (prevRect.bottom < thresholdStart) {
                previousArticle.classList.remove('--article-forward');
              }
            }

            // Get the year from the article's data attribute
            const articleYear = article.getAttribute('data-year');

            if (!articleYear) continue;

            // Get current active year
            const activeButton = timeline.querySelector('.timeline-year-item.--active > .timeline-year');
            const currentYear = activeButton ? activeButton.getAttribute('data-year') : null;

            // If year changed, update the timeline
            if (articleYear && articleYear !== currentYear) {
              const yearButton = timeline.querySelector(`.timeline-year[data-year="${articleYear}"]`);
              if (yearButton) {
                setActiveYear(yearButton);
                updateTimelinePosition(yearButton);
              }
            }

            break; // Stop after finding the first visible article
          }
        }
      }
    }

    // Check if element is entirely in viewport
    function isElementEntirelyInViewport(el) {
      if (!el) return false;

      const rect = el.getBoundingClientRect();

      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    }

    // Check if element is partially in viewport
    function isElementInViewport(el) {
      if (!el) return false;

      const rect = el.getBoundingClientRect();

      return (
        rect.bottom > 0 &&
        rect.right > 0 &&
        rect.left < (window.innerWidth || document.documentElement.clientWidth) &&
        rect.top < (window.innerHeight || document.documentElement.clientHeight)
      );
    }

    // Setup resize listener
    function setupResizeListener() {
      let resizeTimeout;

      window.addEventListener('resize', function () {
        if (resizeTimeout) {
          window.cancelAnimationFrame(resizeTimeout);
        }

        resizeTimeout = window.requestAnimationFrame(function () {
          currentWindowHeight = window.innerHeight;
          timelines.forEach(checkTimelineInViewport);
        });
      });
    }

    // Setup scroll listener
    function setupScrollListener() {
      let scrollTimeout;

      window.addEventListener('scroll', function () {
        if (scrollTimeout) {
          window.cancelAnimationFrame(scrollTimeout);
        }

        scrollTimeout = window.requestAnimationFrame(function () {
          timelines.forEach(checkTimelineInViewport);
        });
      });
    }
  });
})();